import { render } from "./website-sidebar.vue?vue&type=template&id=424dbcc0&scoped=true"
import script from "./website-sidebar.vue?vue&type=script&lang=js"
export * from "./website-sidebar.vue?vue&type=script&lang=js"

import "./website-sidebar.vue?vue&type=style&index=0&id=424dbcc0&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-424dbcc0"]])

export default __exports__